import dayjs from 'dayjs'
import { defineStore } from 'pinia'

export const useSystemStore = defineStore(
  'system',
  () => {
    const now = ref(dayjs())
    const target = dayjs('2025-03-20 00:00:00')
    const isUpdate = computed(() => {
      return import.meta.env.MODE === 'development' ? true : now.value.isAfter(target)
    })
    setInterval(() => {
      now.value = dayjs()
    }, 1000)
    return {
      isUpdate,
    }
  },
  {
    persist: true,
  },
)
